module.exports = __webpack_public_path__ + "fad891c86fffc3a740d35c1bd7eb5496.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_4.jpg
// module id = 1677
// module chunks = 5